<template>
  <el-table
      :data="requests"
      style="width: 100%">
    <el-table-column
        prop="uuid"
        label="ID" />

    <el-table-column
        prop="device_id"
        label="Device ID" />

    <el-table-column
        prop="type"
        label="type" />

    <el-table-column
        prop="state"
        label="State" />

    <el-table-column
        prop="agent"
        label="Agent" />

    <el-table-column
        prop="created_at"
        label="Date" />

    <el-table-column
        prop="comment"
        label="Comment" />
  </el-table>
</template>

<script>
export default {
  name: "AccessoryRelatedRequests",
  props: {
    registries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    timeZone() {
      return this.$store.getters["ui/currentTimezone"];
    },
    requests() {
      return this.registries.map((record) => {
        record.created_at = this.$moment
          .tz(self.created_at, this.timeZone)
          .format("MM/DD/YYYY - hh:mm A Z (z)");
        return record;
      });
    },
  },
  methods: {},
};
</script>

<style scoped></style>
